export interface PricingTier {
  id: "starter" | "growth" | "enterprise";
  name: string;
  price: string;
  priceCadence?: string;
  blurb: string;
  features: string[];
  ctaLabel: string;
  ctaHref: string;
  highlight?: boolean;
}

export const PRICING_TIERS: PricingTier[] = [
  {
    id: "starter",
    name: "Starter",
    price: "$99",
    priceCadence: "per month",
    blurb: "For founders hiring their first teammate.",
    features: [
      "2 agents",
      "1 client workspace",
      "Email support",
      "Community Slack",
      "Standard integrations",
    ],
    ctaLabel: "Start for $99",
    ctaHref: "/register?plan=starter",
  },
  {
    id: "growth",
    name: "Growth",
    price: "$499",
    priceCadence: "per month",
    blurb: "For teams running a full virtual desk.",
    features: [
      "10 agents",
      "3 client workspaces",
      "Priority support",
      "All integrations (GitHub, Slack, Gmail, Twilio)",
      "Custom approval workflows",
    ],
    ctaLabel: "Start Growth",
    ctaHref: "/register?plan=growth",
    highlight: true,
  },
  {
    id: "enterprise",
    name: "Enterprise",
    price: "Custom",
    blurb: "For organizations with compliance, SSO, and scale.",
    features: [
      "Unlimited agents",
      "SSO, audit logs, DPA",
      "Dedicated CSM and Slack channel",
      "99.9% uptime SLA",
      "Custom agent roles on request",
    ],
    ctaLabel: "Book a call",
    ctaHref: "/contact",
  },
];

export interface PricingMatrixRow {
  label: string;
  starter: string | boolean;
  growth: string | boolean;
  enterprise: string | boolean;
}

export const PRICING_MATRIX: PricingMatrixRow[] = [
  { label: "Agents included", starter: "2", growth: "10", enterprise: "Unlimited" },
  { label: "Client workspaces", starter: "1", growth: "3", enterprise: "Unlimited" },
  { label: "Tenant data isolation", starter: true, growth: true, enterprise: true },
  { label: "Human-in-the-loop approvals", starter: true, growth: true, enterprise: true },
  { label: "GitHub, Slack, Gmail integrations", starter: "Limited", growth: true, enterprise: true },
  { label: "Twilio voice agent", starter: false, growth: true, enterprise: true },
  { label: "Audit log export", starter: false, growth: true, enterprise: true },
  { label: "Custom agent prompts", starter: false, growth: true, enterprise: true },
  { label: "SSO (SAML, OIDC)", starter: false, growth: false, enterprise: true },
  { label: "Data processing agreement", starter: false, growth: false, enterprise: true },
  { label: "Dedicated success manager", starter: false, growth: false, enterprise: true },
  { label: "99.9% uptime SLA", starter: false, growth: false, enterprise: true },
  { label: "Support response", starter: "48h email", growth: "8h priority", enterprise: "1h, dedicated Slack" },
];
